import Loader from '@/components/Loader';
import React, { ReactNode } from 'react';
import styles from './style.module.css';

export type Size = 'small' | 'medium' | 'big';
export type Variant = 'primary' | 'secondary' | 'ghost';

export type ButtonProps = {
  size?: Size;
  variant?: Variant;
  loading?: boolean;
  icon?: ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button: React.FC<ButtonProps> = ({
  size = 'medium',
  variant = 'primary',
  loading = false,
  icon,
  children,
  ...props
}) => {
  const renderIcon = () => {
    if (loading) {
      return <Loader buttonType={variant} />;
    }
    if (icon) return icon;
  };

  return (
    <button
      className={`${styles.button} ${styles[size]} ${styles[variant]}`}
      {...props}
    >
      {/* content div is necessary for double border on focus */}
      <div className={styles.content}>
        {renderIcon()}
        {children}
      </div>
    </button>
  );
};

export default Button;
